import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caret",
  "use": "caret-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol viewBox=\"0 0 10 7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"caret\">\n    <path d=\"M1 1L5 5L9 1\" stroke=\"inherit\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol